module.exports = __webpack_public_path__ + "static/game-809b48c95d105cfa43a33d6cdf5c0f23.gif";